var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2283_1287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5451 0H19.7702L12.689 8.06273L20.9621 19H14.4698L9.38682 12.3535L3.56763 19H0.342539L7.84438 10.3764L-0.078125 0H6.57538L11.1676 6.07159L16.5451 0ZM15.4163 17.107H17.2042L5.6359 1.82288H3.71486L15.4163 17.107Z",
    fill: "#1A1B32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2283_1287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.0332,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXLogo);
export default __webpack_public_path__ + "static/media/X_logo.fd7412f2f57d09b2d2c8899142702151.svg";
export { ForwardRef as ReactComponent };